import { ArrowUp, ArrowDown, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export default function TrendIcon({ direction = "flat", className = "" }) {
  if (direction === "up") {
    return <ArrowUp className={cn("w-4 h-4 text-green-500", className)} strokeWidth={2.6} />;
  }
  if (direction === "down") {
    return <ArrowDown className={cn("w-4 h-4 text-red-500", className)} strokeWidth={2.6} />;
  }
  return <ArrowRight className={cn("w-4 h-4 text-ink-400", className)} strokeWidth={2.6} />;
}
